var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinusBtnMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_133_784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 0C11.2083 0 9.52084 0.338538 7.9375 1.01562C6.35416 1.69271 4.97396 2.61979 3.79688 3.79688C2.61979 4.97396 1.69271 6.35416 1.01562 7.9375C0.338538 9.52084 0 11.2083 0 13C0 14.7917 0.338538 16.4792 1.01562 18.0625C1.69271 19.6458 2.61979 21.026 3.79688 22.2031C4.97396 23.3802 6.35416 24.3073 7.9375 24.9844C9.52084 25.6615 11.2083 26 13 26C14.7917 26 16.4792 25.6615 18.0625 24.9844C19.6458 24.3073 21.026 23.3802 22.2031 22.2031C23.3802 21.026 24.3073 19.6458 24.9844 18.0625C25.6615 16.4792 26 14.7917 26 13C26 11.2083 25.6615 9.52084 24.9844 7.9375C24.3073 6.35416 23.3802 4.97396 22.2031 3.79688C21.026 2.61979 19.6458 1.69271 18.0625 1.01562C16.4792 0.338538 14.7917 0 13 0ZM19.5 13.375C19.5 13.6458 19.401 13.8802 19.2031 14.0781C19.0052 14.276 18.7708 14.375 18.5 14.375H7.5C7.22917 14.375 6.99479 14.276 6.79688 14.0781C6.59896 13.8802 6.5 13.6458 6.5 13.375V12.375C6.5 12.1042 6.59896 11.8698 6.79688 11.6719C6.99479 11.474 7.22917 11.375 7.5 11.375H18.5C18.7708 11.375 19.0052 11.474 19.2031 11.6719C19.401 11.8698 19.5 12.1042 19.5 12.375V13.375Z",
    fill: "#B51700",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_133_784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusBtnMenu);
export default __webpack_public_path__ + "static/media/minus-btn-menu.9cfa7a331469e2d61865bba27d0fa407.svg";
export { ForwardRef as ReactComponent };